import React from 'react';
import { isOverdue } from '../lib/format';

const MAP = {
  paid:      { label: 'ZAPLATENÁ',     bg: 'var(--success-dim)', fg: 'var(--success)'  },
  issued:    { label: 'VYSTAVENÁ',     bg: 'var(--info-dim)',    fg: 'var(--info)'     },
  overdue:   { label: 'PO SPLATNOSTI', bg: 'var(--danger-dim)',  fg: 'var(--danger)'   },
  draft:     { label: 'KONCEPT',       bg: 'rgba(0,0,0,0.05)',   fg: 'var(--text-secondary)' },
  cancelled: { label: 'ZRUŠENÁ',       bg: 'rgba(0,0,0,0.05)',   fg: 'var(--text-muted)' },
};

export default function StatusPill({ status, invoice }) {
  // Auto-promote to overdue if past due_date and not paid
  let st = status;
  if (invoice && st !== 'paid' && st !== 'cancelled' && isOverdue(invoice)) st = 'overdue';
  const m = MAP[st] || MAP.draft;
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        padding: '3px 9px',
        borderRadius: 'var(--r-full)',
        background: m.bg,
        color: m.fg,
        fontSize: 10,
        fontWeight: 700,
        letterSpacing: '0.04em',
      }}
    >
      {m.label}
    </span>
  );
}
